import {
  BoardPermissions,
  getDefaultBoardPermissions,
  combineBoardPermissions,
  isCorrectBoardPermissions,
  nothingAllowedBoardPermissions
} from './board-permissions'
import {ProjectChildPermission} from './permission-object'

export interface ProjectPermissions {
  editTitle: boolean
  delete: boolean
  addBoard: boolean

  boards: BoardPermissions

  // for permission exceptions inside project
  // if some board/column/task has different set of permissions
  children?: {
    [id: string]: ProjectChildPermission
  }
}

export const allowAllOnProject = (
  perm: ProjectPermissions
): ProjectPermissions => {
  return {...perm, editTitle: true, delete: true, addBoard: true}
}

export const disallowAllOnProject = (
  perm: ProjectPermissions
): ProjectPermissions => {
  return {...perm, editTitle: false, delete: false, addBoard: false}
}

export const nothingAllowedProjectPermissions = (): ProjectPermissions => ({
  editTitle: false,
  delete: false,
  addBoard: false,
  boards: nothingAllowedBoardPermissions(),
  children: {}
})

export const getDefaultProjectPermissions = (): ProjectPermissions => {
  return {
    editTitle: true,
    delete: true,
    addBoard: true,
    boards: getDefaultBoardPermissions()
  }
}

export const isCorrectProjectPermissions = (p: ProjectPermissions): boolean => {
  return !!p && isCorrectBoardPermissions(p.boards)
}

export const combineProjectPermissions = (
  a: ProjectPermissions,
  b: ProjectPermissions
): ProjectPermissions => {
  if (!a) {
    return b
  }
  if (!b) {
    return a
  }
  return {
    editTitle: a.editTitle || b.editTitle,
    delete: a.delete || b.delete,
    addBoard: a.addBoard || b.addBoard,
    boards: combineBoardPermissions(a.boards, b.boards),
    children:
      a.children || b.children
        ? {
            ...(a.children ?? {}),
            ...(b.children ?? {})
          }
        : undefined
  }
}
